import { RootAction } from '@src/app/_redux';
import { combineReducers } from 'redux';
import {
  CLIENT_CONFIG_LOADING,
  CLIENT_CONFIG_SUCCESS,
  CLIENT_CONFIG_FAILURE,
  NATGEO_FOOTER_LINKS_SUCCESS,
} from '@src/app/main/actions';

export const initialState = {
  clientConfig: {},
};
export const adminInitialState = {
  adminConfig: {},
};
export const natGeoFooterLinksInitialState = {
  natGeoFooterLinks: {},
};
export type State = {
  initialState: ConfigState;
  adminInitialState: AdminConfigState;
  natGeoFooterLinksInitialState: NatGeoFooterLinksState
};
export const clientConfig = combineReducers<ConfigState, RootAction>({
  clientConfig: (state = initialState.clientConfig, { type, payload }) => {
    switch (type) {
      case CLIENT_CONFIG_SUCCESS:
        return payload.clientConfig;
      default:
        return state;
    }
  },
  configLoading: (state = false, action) => {
    switch (action.type) {
      case CLIENT_CONFIG_LOADING:
        return action.payload;
      case CLIENT_CONFIG_FAILURE:
      case CLIENT_CONFIG_SUCCESS:
        return false;
      default:
        return state;
    }
  },
  configFailure: (state = false, action) => {
    switch (action.type) {
      case CLIENT_CONFIG_FAILURE:
        return true;
      case CLIENT_CONFIG_SUCCESS:
        return false;
      default:
        return state;
    }
  },
  errorMessage: (state = null, action) => {
    switch (action.type) {
      case CLIENT_CONFIG_FAILURE:
        return action.payload;
      case CLIENT_CONFIG_SUCCESS:
        return null;
      default:
        return state;
    }
  },
  configLoaded: (state = false, action) => {
    switch (action.type) {
      case CLIENT_CONFIG_LOADING:
      case CLIENT_CONFIG_FAILURE:
        return false;
      case CLIENT_CONFIG_SUCCESS:
        return true;
      default:
        return state;
    }
  },
});
export interface ConfigState {
  errorMessage: any;
  clientConfig?: any;
  configLoaded: boolean;
  configLoading: boolean;
  configFailure: boolean;
}
export const adminConfig = combineReducers<AdminConfigState, RootAction>({
  adminConfig: (state = adminInitialState.adminConfig, { type, payload }) => {
    switch (type) {
      case CLIENT_CONFIG_SUCCESS:
        return payload.adminConfig;
      default:
        return state;
    }
  },
});
export interface AdminConfigState {
  adminConfig?: any;
}
export const natGeoFooterLinks = combineReducers<NatGeoFooterLinksState, RootAction>({
  natGeoFooterLinks: (state = natGeoFooterLinksInitialState.natGeoFooterLinks, { type, payload }) => {
    switch (type) {
      case   NATGEO_FOOTER_LINKS_SUCCESS:
        return payload;
      default:
        return state;
    }
  },
});
export interface NatGeoFooterLinksState {
  natGeoFooterLinks?: any;
}
